import React from 'react'
import styled from 'styled-components'
import { Icon } from './Icon'

export type AbwSectionHeaderProps = {
	title: React.ReactNode
	/** Small blue count next to the title. */
	count?: number
	/** Renders a "see all" inline link when provided. */
	onSeeAll?: () => void
	seeAllLabel?: string
	className?: string
}

/** Section heading (design): bold title + small blue count, optional "see all". */
export const SectionHeader: React.FC<AbwSectionHeaderProps> = ({ title, count, onSeeAll, seeAllLabel = 'عرض الكل', className }) => (
	<Head className={className}>
		<h2>
			{title}
			{typeof count === 'number' && <span className="count">{count}</span>}
		</h2>
		{onSeeAll && (
			<button type="button" onClick={onSeeAll}>
				{seeAllLabel}
				<Chevron>
					<Icon name="chevron-left" size={14} />
				</Chevron>
			</button>
		)}
	</Head>
)

const Head = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--space-3);
	h2 {
		margin: 0;
		display: flex;
		align-items: baseline;
		gap: 6px;
		font: var(--fw-bold) 15px var(--font-sans);
		color: var(--text-primary);
		.count {
			font: var(--fw-bold) var(--fs-label) var(--font-sans);
			color: var(--blue);
		}
	}
	button {
		border: none;
		background: none;
		padding: 0;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 2px;
		font: var(--fw-bold) 13px var(--font-sans);
		font-family: var(--font-sans);
		color: var(--blue);
		white-space: nowrap;
	}
`
/* forward chevron: left in RTL, mirrored for LTR */
const Chevron = styled.span`
	display: flex;
	html:not([dir='rtl']) & {
		transform: scaleX(-1);
	}
`
